import { atom } from "jotai"
import { Item } from "../libs/api/backend/src"

interface TotalSumProps {
  priceOut: string
  priceDiscount: string
}

export const searchTextAtom = atom("")
export const checkoutModalDiscountOpenAtom = atom(false)
export const checkoutIsNeedCalculateSumBackAtom = atom(false)
export const checkoutItemsAtom = atom<Array<Item>>([])
export const checkoutDiscountAtom = atom<string>("0")
export const checkoutRaisePercentAtom = atom<string>("0")
export const checkoutStepAtom = atom<string>("0")
export const checkoutSumGiveAtom = atom<string>("0")

export const checkoutSumsAtom = atom((get) => {
  let totalPriceOut = 0
  let totalPriceDiscount = 0
  const checkoutItems = get(checkoutItemsAtom)

  for (let i = 0; i < checkoutItems.length; i++) {
    const count = Number(checkoutItems[i].count) || 0
    totalPriceOut += (Number(checkoutItems[i].priceOut) || 0) * count
    totalPriceDiscount += (Number(checkoutItems[i].priceDiscount) || 0) * count
  }

  return {
    priceOut: String(Math.round(totalPriceOut * 100) / 100),
    priceDiscount: String(Math.round(totalPriceDiscount * 100) / 100),
  } as TotalSumProps
})

export const checkoutSumRaiseAtom = atom((get) => {
  const { priceDiscount } = get(checkoutSumsAtom)
  const raisePercent = get(checkoutRaisePercentAtom)

  const priceDiscountNum = Number(priceDiscount) || 0
  const raisePercentNum = Number(raisePercent) || 0

  // Add sum to raise
  if (raisePercentNum <= 0) {
    return "0"
  }

  const result = (priceDiscountNum * raisePercentNum) / 100
  return String(Math.round(result * 100) / 100)
})

export const checkoutSumTotalAtom = atom((get) => {
  const { priceDiscount } = get(checkoutSumsAtom)
  const discount = get(checkoutDiscountAtom)
  const raisePercentSum = get(checkoutSumRaiseAtom)

  let total = Number(priceDiscount) || 0
  const raisePercentSumNum = Number(raisePercentSum) || 0

  // Add sum to raise
  if (raisePercentSumNum > 0) {
    total += raisePercentSumNum
  }

  const discountNum = Number(discount) || 0
  total = Math.max(0, total - discountNum)

  return String(Math.round(total * 100) / 100)
})

export const checkoutSumBackAtom = atom((get) => {
  const isNeedCalculateSumBack = get(checkoutIsNeedCalculateSumBackAtom)

  if (isNeedCalculateSumBack) {
    return "0"
  }

  const sumTotal = Number(get(checkoutSumTotalAtom)) || 0
  const sumGive = Number(get(checkoutSumGiveAtom)) || 0

  const back = sumGive - sumTotal
  return String(Math.round(back * 100) / 100)
})

export const checkoutDiscountButtonDisabledAtom = atom<boolean>((get) => {
  const step = get(checkoutStepAtom)
  const { priceDiscount } = get(checkoutSumsAtom)

  return !((step === "0" || step === "1") && (Number(priceDiscount) || 0) > 0)
})

export const checkoutIsStep0 = atom((get) => get(checkoutStepAtom) === "0")
export const checkoutIsStep1 = atom((get) => get(checkoutStepAtom) === "1")

export const checkoutNextButtonDisabledAtom = atom((get) => {
  const step = get(checkoutStepAtom)
  const sumTotal = Number(get(checkoutSumTotalAtom)) || 0
  const sumGive = Number(get(checkoutSumGiveAtom)) || 0

  switch (step) {
    // Search items
    case "0":
      return !get(checkoutItemsAtom).length
    // Choose payment and add sum
    case "1":
      return sumGive < sumTotal
  }
})
